import { findLoaderScript, mountWidget } from "./loader-core";

const script = findLoaderScript(document, import.meta.url);

if (!(script instanceof HTMLScriptElement)) {
  console.error("Custom RAG Chatbot loader must run from a script element");
} else {
  try {
    mountWidget(script);
  } catch (error) {
    console.error("Custom RAG Chatbot could not start", error);
  }
}
